import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'open-tile-block',
  templateUrl: './open-tile-block.component.html',
  styleUrls: ['./open-tile-block.component.scss']
})
export class OpenTileBlockComponent implements OnInit {
  @Input() title!: string;
  @Input() text!: string;
  @Input() tileClass: string = '';
  @Input() actionText?: string;
  @Input() noAction?: boolean;
  @Input() actionInProgress?: boolean;
  @Input() icon?: string;
  @Output() action = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  tileAction() {
    if (this.tileClass !== 'tertiary') {
      this.executeAction();
    }
  }

  executeAction() {
    this.action.emit();
  }
}
